(function () {
  Flint.file('mframework/views/volumeBars.js', function (require) {
    var lastVolumeSetting = atom(0.5);

    Flint.staticStyles('VolumeBars', {
      '$': '#_flintapp .ViewVolumeBars',
      '$mouseTarget': '#_flintapp mouseTarget.VolumeBars, #_flintapp .VolumeBars.mouseTarget, #_flintapp .ViewVolumeBars.mouseTarget, #_flintapp .VolumeBars > .mouseTarget',
      '$bar': '#_flintapp bar.VolumeBars, #_flintapp .VolumeBars.bar, #_flintapp .ViewVolumeBars.bar, #_flintapp .VolumeBars > .bar'
    }, {
      '$': {
        flexDirection: 'row'
      },
      '$mouseTarget': {
        cursor: 'pointer'
      },
      '$bar': {
        borderStyle: 'solid',
        borderColor: '#ccc',
        borderWidth: 1
      }
    });
    Flint.view('VolumeBars', function (view, on, $) {
      var context = initContext(view, {
        colors: atom()
      });

      var pro = initPro(view, {
        height: M.defaultAtom(30),
        initialVolume: M.defaultAtom(null),
        inverted: M.defaultAtom(false),
        numBars: M.defaultAtom(5),
        volume: atom(),
        width: M.defaultAtom(30)
      });

      var spacerWidth = atom(1);
      var selectedColor = atom(context.colors.get().accent);
      var hoveringColor = atom('rgba(221, 19, 123, 0.5)');

      var barWidth = derivation(function () {
        return (pro.width.get() - spacerWidth.get() * (pro.numBars.get() - 1)) / pro.numBars.get();
      });
      var getBarHeight = function getBarHeight(barIndex) {
        var heightFraction = (barIndex + 1) / pro.numBars.get();
        return heightFraction * pro.height.get();
      };
      var barBorderRadius = derivation(function () {
        return barWidth.get() / 2 + 2;
      });

      var desiredVolume = atom(pro.initialVolume.get());
      var hoveringBarIndex = atom(null);

      pro.volume.react(function (propVolume) {
        if (propVolume !== undefined) {
          desiredVolume.set(propVolume);
        }
      });

      var volume = derivation(function () {
        return desiredVolume.get() == null ? lastVolumeSetting.get() : desiredVolume.get();
      });
      volume.react(function (initialVolume) {
        view.props.onInit && view.props.onInit({ volume: initialVolume });
      }, { once: true });

      var selectedBarIndex = volume.derive(function (volume) {
        return Math.ceil(volume * pro.numBars.get()) - 1;
      });

      var setSelectedBarIndex = function setSelectedBarIndex(i) {
        var userDesiredVolume = (i + 1) / pro.numBars.get();
        transact(function () {
          desiredVolume.set(userDesiredVolume);
          lastVolumeSetting.set(userDesiredVolume);
        });
        if (view.props.onChange) {
          view.props.onChange({ volume: volume.get() });
        }
      };view.render(function () {
        return Flint.range(pro.numBars.get()).map(function (_, _index) {
          return view.el(
            ['mouseTarget', 1, _, _index],
            { repeat: pro.numBars.get(),
              onMouseEnter: function () {
                return hoveringBarIndex.set(_index);
              },
              onMouseLeave: function () {
                return hoveringBarIndex.set(null);
              },
              onClick: function () {
                return setSelectedBarIndex(_index);
              }
            },
            view.el(['bar', 1, _, _index], null)
          );
        });
      });

      $["mouseTarget"] = function (_, _index) {
        return { height: pro.height.get(),
          justifyContent: pro.inverted.get() ? 'flex-start' : 'flex-end'
        };
      };

      $["bar"] = function (_, _index) {
        return {
          background: hoveringBarIndex.get() == null || hoveringBarIndex.get() == selectedBarIndex.get() ? _index <= selectedBarIndex.get() ? selectedColor.get() : 'white' : _index <= hoveringBarIndex.get() ? hoveringColor.get() : 'white', width: barWidth.get(),
          height: getBarHeight(_index),
          borderRadius: pro.inverted.get() ? [0, 0, barBorderRadius.get(), barBorderRadius.get()] : [barBorderRadius.get(), barBorderRadius.get(), 0, 0],
          marginRight: _index < pro.numBars.get() - 1 ? spacerWidth.get() : null
        };
      };
    });
  })
})();
//# sourceMappingURL=volumeBars.js.map
